const STUDENT_MESSAGE_VARIABLES = [
  { value: "{aluno}", label: "Nome do aluno" },
  { value: "{faltas}", label: "Quantidade de faltas" },
  { value: "{dias}", label: "Dias das faltas" },
];

const ATTENDEE_MESSAGE_VARIABLES = [
  { value: "{atendido}", label: "Nome do atendido" },
  { value: "{faltas}", label: "Quantidade de faltas" },
  { value: "{dias}", label: "Dias das faltas" },
];

const messageVariableContext = (textarea) => {
  const attendeeContext = Boolean(textarea.closest(".attendees"));
  return {
    variables: attendeeContext
      ? ATTENDEE_MESSAGE_VARIABLES
      : STUDENT_MESSAGE_VARIABLES,
    className: attendeeContext
      ? "attendees__message-variable-picker"
      : "students__message-variable-picker",
    scope: attendeeContext ? "attendee" : "student",
  };
};

const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Ativo" },
  { value: "IN_PROCESS", label: "Em processo" },
  { value: "INACTIVE", label: "Inativo" },
];

const SETTINGS_PATHS = [
  "/api/student-management/settings",
  "/student-management/settings",
];

const authHeaders = () => {
  const token = window.localStorage?.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const requestSettings = async (method = "GET", payload) => {
  let lastError;
  for (const path of SETTINGS_PATHS) {
    try {
      const response = await fetch(path, {
        method,
        headers: {
          Accept: "application/json",
          ...(payload ? { "Content-Type": "application/json" } : {}),
          ...authHeaders(),
        },
        ...(payload ? { body: JSON.stringify(payload) } : {}),
      });
      if (response.status === 404) continue;
      if (!response.ok) {
        const details = await response.json().catch(() => ({}));
        throw new Error(details?.error || "Não foi possível salvar a configuração.");
      }
      return response.json();
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError || new Error("Não foi possível acessar as configurações.");
};

const setNativeValue = (element, value) => {
  const prototype = element instanceof HTMLTextAreaElement
    ? HTMLTextAreaElement.prototype
    : element instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(prototype, "value")?.set;
  if (setter) setter.call(element, value);
  else element.value = value;
};

const dispatchValueChange = (element) => {
  element.dispatchEvent(new Event("input", { bubbles: true }));
  element.dispatchEvent(new Event("change", { bubbles: true }));
};

const installMessageVariablePicker = () => {
  const textareas = Array.from(document.querySelectorAll("textarea")).filter((item) =>
    item.closest("label")?.textContent?.includes("Mensagem personalizada para WhatsApp"),
  );

  textareas.forEach((textarea) => {
    if (textarea.dataset.messageVariablePicker === "true") return;
    textarea.dataset.messageVariablePicker = "true";
    const context = messageVariableContext(textarea);

    const row = document.createElement("div");
    row.className = context.className;
    row.dataset.messageVariableScope = context.scope;
    row.style.cssText = "display:grid;grid-template-columns:minmax(0,1fr) auto;gap:8px;margin-top:8px;";

    const select = document.createElement("select");
    select.setAttribute("aria-label", "Variável da mensagem de baixa frequência");
    context.variables.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.value;
      option.textContent = `${item.label} — ${item.value}`;
      select.appendChild(option);
    });

    const button = document.createElement("button");
    button.type = "button";
    button.textContent = "Acrescentar no texto";
    button.addEventListener("click", () => {
      const token = select.value;
      const current = textarea.value || "";
      const start = Number.isInteger(textarea.selectionStart)
        ? textarea.selectionStart
        : current.length;
      const end = Number.isInteger(textarea.selectionEnd)
        ? textarea.selectionEnd
        : start;
      const next = `${current.slice(0, start)}${token}${current.slice(end)}`;
      setNativeValue(textarea, next);
      dispatchValueChange(textarea);
      textarea.focus();
      const cursor = start + token.length;
      textarea.setSelectionRange(cursor, cursor);
    });

    row.append(select, button);
    textarea.insertAdjacentElement("afterend", row);
  });
};

const restoreNativeSettingsContent = (container) => {
  container.querySelectorAll("[data-student-integration-hidden='true']").forEach((element) => {
    element.style.display = element.dataset.previousDisplay || "";
    delete element.dataset.studentIntegrationHidden;
    delete element.dataset.previousDisplay;
  });
  container.querySelector("[data-student-integration-panel]")?.setAttribute("hidden", "");
  container.querySelector("[data-student-integration-tab]")?.classList.remove("active");
};

const installIntegrationTab = () => {
  const navigation = document.querySelector(".students__config-tabs");
  if (navigation?.dataset?.diarySettings === 'true') return;
  if (!navigation || navigation.querySelector("[data-student-integration-tab]")) return;
  const container = navigation.parentElement;
  if (!container) return;

  const button = document.createElement("button");
  button.type = "button";
  button.dataset.studentIntegrationTab = "true";
  button.textContent = "Integração de Formulário";

  const panel = document.createElement("div");
  panel.dataset.studentIntegrationPanel = "true";
  panel.className = "students__mini";
  panel.hidden = true;
  panel.innerHTML = `
    <strong>Integração de Formulário</strong>
    <p>Escolha o status que será pré-selecionado no campo “Status do aluno” dos formulários integrados ao BPM.</p>
    <label style="display:flex;flex-direction:column;gap:7px;max-width:460px;">
      Status padrão do aluno
      <select data-student-default-status aria-label="Status padrão dos formulários integrados">
        ${STATUS_OPTIONS.map((item) => `<option value="${item.value}">${item.label}</option>`).join("")}
      </select>
    </label>
    <p style="color:#64748b;">O campo será incluído nos formulários integrados. Se ele for excluído no Form Builder, o cadastro usará este status automaticamente.</p>
    <div style="display:flex;align-items:center;gap:12px;">
      <button type="button" data-save-student-integration>Salvar integração</button>
      <span data-student-integration-feedback aria-live="polite"></span>
    </div>
  `;

  navigation.appendChild(button);
  navigation.insertAdjacentElement("afterend", panel);

  const statusSelect = panel.querySelector("[data-student-default-status]");
  const saveButton = panel.querySelector("[data-save-student-integration]");
  const feedback = panel.querySelector("[data-student-integration-feedback]");
  let loadedSettings = null;

  const load = async () => {
    try {
      loadedSettings = await requestSettings();
      statusSelect.value = loadedSettings?.integratedFormDefaultStudentStatus || "IN_PROCESS";
    } catch (error) {
      feedback.textContent = error?.message || "Não foi possível carregar a configuração.";
    }
  };

  button.addEventListener("click", async () => {
    Array.from(navigation.children).forEach((child) => child.classList.remove("active"));
    button.classList.add("active");
    Array.from(container.children).forEach((child) => {
      if (child === navigation || child === panel) return;
      child.dataset.previousDisplay = child.style.display || "";
      child.dataset.studentIntegrationHidden = "true";
      child.style.display = "none";
    });
    panel.hidden = false;
    if (!loadedSettings) await load();
  });

  navigation.addEventListener("click", (event) => {
    if (event.target === button || button.contains(event.target)) return;
    restoreNativeSettingsContent(container);
  }, true);

  saveButton.addEventListener("click", async () => {
    saveButton.disabled = true;
    feedback.textContent = "Salvando...";
    try {
      const latest = await requestSettings();
      loadedSettings = await requestSettings("PUT", {
        ...latest,
        integratedFormDefaultStudentStatus: statusSelect.value,
      });
      statusSelect.value = loadedSettings.integratedFormDefaultStudentStatus || statusSelect.value;
      feedback.textContent = "Configuração salva.";
    } catch (error) {
      feedback.textContent = error?.message || "Não foi possível salvar.";
    } finally {
      saveButton.disabled = false;
    }
  });
};

const applyIntegratedStatusDefault = () => {
  document.querySelectorAll("select#student_status").forEach((select) => {
    if (select.value) return;
    const firstValue = Array.from(select.options).find((option) => option.value)?.value;
    if (!firstValue) return;
    setNativeValue(select, firstValue);
    dispatchValueChange(select);
  });
};

const synchronize = () => {
  installMessageVariablePicker();
  installIntegrationTab();
  applyIntegratedStatusDefault();
};

const isMessageTemplateTextarea = (element) =>
  element.matches?.("textarea") &&
  element.closest("label")?.textContent?.includes("Mensagem personalizada para WhatsApp");

const addedNodeNeedsSynchronization = (node) => {
  if (!(node instanceof Element)) return false;
  if (node.matches(".students__config-tabs, select#student_status")) return true;
  if (isMessageTemplateTextarea(node)) return true;
  if (node.querySelector(".students__config-tabs, select#student_status")) return true;
  return Array.from(node.querySelectorAll("textarea")).some(isMessageTemplateTextarea);
};

let synchronizeScheduled = false;
const scheduleSynchronize = () => {
  if (synchronizeScheduled) return;
  synchronizeScheduled = true;
  const run = () => {
    synchronizeScheduled = false;
    synchronize();
  };
  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(run);
  } else {
    window.setTimeout(run, 0);
  }
};

const installScopedObserver = () => {
  const root = document.getElementById("root") || document.body;
  if (!root) return;

  window.__studentSettingsEnhancementsObserver?.disconnect?.();
  const observer = new MutationObserver((records) => {
    const relevantMutation = records.some((record) =>
      Array.from(record.addedNodes || []).some(addedNodeNeedsSynchronization),
    );
    if (relevantMutation) scheduleSynchronize();
  });
  observer.observe(root, { childList: true, subtree: true });
  window.__studentSettingsEnhancementsObserver = observer;
};

const start = () => {
  synchronize();
  installScopedObserver();
};

if (typeof window !== "undefined" && typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
}

/* Student-react-settings-tabs-v1 */
